import { render, staticRenderFns } from "./ownerRepairManageList.vue?vue&type=template&id=08b8e8e2&scoped=true"
import script from "./ownerRepairManageList.vue?vue&type=script&lang=js"
export * from "./ownerRepairManageList.vue?vue&type=script&lang=js"
import style0 from "./ownerRepairManageList.vue?vue&type=style&index=0&id=08b8e8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b8e8e2",
  null
  
)

export default component.exports